// extracted by mini-css-extract-plugin
export var aircallIframe = "_ig-3";
export var fabContainer = "_ig-5";
export var fabRinging = "_ig-6";
export var loadingOverlay = "_ig-4";
export var pulse = "_ig-7";
export var widgetContent = "_ig-2";
export var widgetPanel = "_ig-0";
export var widgetPanelExpanded = "_ig-1";